import { Form, Input } from '@arco-design/web-react';

import { formJsonFieldFormatter, formJsonFieldNormalize } from '@/delivery-type-plugin/capabilities/maas-init/utils/jsonFormField';
import { PRIMARY_DATA_VOLUME_FIELD } from '@/delivery-type-plugin/capabilities/maas-node-groups/masterGroupForm';

const FormItem = Form.Item;

/** StepForm 始终挂载：_primaryDataVolume 以 JSON 字符串登记，避免切步后复杂对象丢失 */
export function MaasPrimaryDataVolumePersistField() {
  return (
    <FormItem
      field={PRIMARY_DATA_VOLUME_FIELD}
      hidden
      style={{ display: 'none', margin: 0 }}
      triggerPropName="value"
      formatter={formJsonFieldFormatter}
      normalize={formJsonFieldNormalize}
    >
      <Input />
    </FormItem>
  );
}

export default MaasPrimaryDataVolumePersistField;
